import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";

export const ErrorMessageCard = ({ message }: { message: string }) => (
  <Card className="border-destructive">
    <CardHeader>
      <CardTitle className="text-lg text-destructive">Error Message</CardTitle>
    </CardHeader>
    <CardContent>
      <pre className="text-sm text-destructive bg-destructive/10 p-4 rounded-lg overflow-x-auto whitespace-pre-wrap">
        {message}
      </pre>
    </CardContent>
  </Card>
);
